import React from 'react';
import './Footer.scss';

function Footer() {
  return (
    <div className="Footer text-center">
      Lets making the world animated,
      Made with &#10084; by Rahul Agrawal
    </div>
  );
}

export default Footer;
